// extracted by mini-css-extract-plugin
export default {"icon":"SeriesIcon-module__icon--Rf7I3","archived":"SeriesIcon-module__archived--TfjtG","animatedBackground":"SeriesIcon-module__animatedBackground--vt3HM"};